import { ComponentType } from "react";
import { MultiValue, MultiValueProps, PropsValue } from "react-select";

import { MultiValueTag } from "@/components/ui/MultiValueTag";
import { filterClasses } from "@/utils/filter-styles";

import { MultiValueOption } from "../../types";
import { TEXT_SEPARATORS } from "../../utils/messages";

type CompactMultiValue = ComponentType<MultiValueProps<MultiValueOption, true>>;

const byLabel: Map<string, CompactMultiValue> = new Map();

const isMultiValue = (
  value: PropsValue<MultiValueOption>
): value is MultiValue<MultiValueOption> => Array.isArray(value);

const selectedOf = (
  value: PropsValue<MultiValueOption>
): MultiValue<MultiValueOption> => (isMultiValue(value) ? value : []);

const createCompactMultiValue = (label: string): CompactMultiValue =>
  function CompactMultiValue(props: MultiValueProps<MultiValueOption, true>): JSX.Element | null {
    const values: MultiValue<MultiValueOption> = selectedOf(props.selectProps.value);

    if (values.length <= 1) return <MultiValueTag {...props} />;

    if (values[0].value !== props.data.value) return null;

    return (
      <div
        title={values.map((option: MultiValueOption): string => option.label).join(TEXT_SEPARATORS.LIST)}
        className={`${filterClasses.multiValueTag} whitespace-nowrap`}
      >
        {label}
        {TEXT_SEPARATORS.LABEL}
        {values.length}
      </div>
    );
  };

export const compactMultiValueFor = (label: string): CompactMultiValue => {
  const cached: CompactMultiValue | undefined = byLabel.get(label);

  if (cached) return cached;

  const created: CompactMultiValue = createCompactMultiValue(label);
  byLabel.set(label, created);

  return created;
};
